import { FormHelperText } from '@mui/material';
import TextField, { BaseTextFieldProps, TextFieldProps } from '@mui/material/TextField';
import axios from 'axios';
import { AsYouType } from 'libphonenumber-js';
import * as React from 'react';
import { FieldValidationType } from '../../../../sic-lib/enums/FieldValidationType';
import { CreateContactFieldError, CreateContactForm } from '../../../../sic-lib/types/Contact';
import { FormFieldCreateContact } from '../../../../sic-lib/types/ContactField';

type Props = Omit<BaseTextFieldProps, 'value'> & {
    field: FormFieldCreateContact<string>;
    fieldKey: keyof CreateContactForm;
    onChangeHandler: (key: keyof CreateContactForm, field: FormFieldCreateContact) => void;
    formErrors: unknown;
};

export default function ContactFormFastField({
    field,
    fieldKey,
    onChangeHandler,
    formErrors,
    ...props
}: Props) {
    const [state, setState] = React.useState<string>(field.value as string);

    const errorText = React.useMemo(() => {
        if (!formErrors) return undefined;

        if (axios.isAxiosError(formErrors) && formErrors.response?.data) {
            //this error checking is fucking stupid.
            const responseData = formErrors.response.data;
            if (Array.isArray(responseData)) {
                const createErrors = responseData as CreateContactFieldError[];
                const actualError = createErrors.find(x => x.relatedId === field.fieldId);
                return actualError?.error;
            }
        }
    }, [formErrors, field]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        switch (field.validationType) {
            case FieldValidationType.usMobilePhone:
                if (event.target.value.includes('(') && !event.target.value.includes(')')) {
                    //fix a case where hitting backspace on a (416 number, reformats back to (416)
                    setState(event.target.value.replace('(', ''));
                } else {
                    setState(new AsYouType('US').input(event.target.value));
                }
                break;
            default:
                setState(event.target.value);
                break;
        }
    };

    const handleBlur = () => {
        if (state !== field.value) {
            onChangeHandler(fieldKey, {
                ...field,
                ...{
                    value: state,
                },
            });
        }
    };

    return (
        <>
            <TextField
                {...(props as TextFieldProps)}
                id={`${field.label}_${field.fieldId}`}
                value={state}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!errorText}
            />
            {errorText && <FormHelperText error={true}>{errorText}</FormHelperText>}
        </>
    );
}
